export default __webpack_public_path__ + "static/media/nodding.afc5977f.gif";